import { render, staticRenderFns } from "./IconList.vue?vue&type=template&id=4be71c5d&scoped=true&"
import script from "./IconList.vue?vue&type=script&lang=ts&"
export * from "./IconList.vue?vue&type=script&lang=ts&"
import style0 from "./IconList.vue?vue&type=style&index=0&id=4be71c5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be71c5d",
  null
  
)

export default component.exports